/* =========================================================================
   GLOWVITAL CART PAGE — interaction layer
   AJAX qty, remove, upsell, extras auto-save, discount, reveal, mobile sticky.
   Vanilla JS, single IIFE, idempotent init guard.
   ========================================================================= */
(function(){
  if (window.__GVC_INIT) return;
  window.__GVC_INIT = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FREE_SHIP_THRESHOLD = 0; /* FREE DELIVERY TEST 15 Sep 2026: every UK order ships free. Restore 2999 (£29.99 in pence, mirrors the General delivery profile) after. */
  var MONEY_FORMAT = '£{{amount}}';

  function qs(sel, ctx){ return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(pence){
    var n = (pence / 100);
    return '£' + n.toFixed(2).replace(/\.00$/, '.00');
  }

  /* ---------- AJAX helpers ---------- */
  function postJSON(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(j){
        if (!r.ok) throw new Error(j.description || j.message || 'Request failed');
        return j;
      });
    });
  }
  function getCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }

  /* ---------- Free-shipping bar update ----------
     Subscription lines are billed by the `subscriptions` delivery profile, which ships
     GB free with NO minimum, so they must never count toward the threshold. Using
     cart.total_price counted them, which told a £30 subscriber they were "£5.00 away"
     from free delivery they already had - and checkout then corrected them. That is
     where the friction came from.

     This mirrors sections/cart-template.liquid, which renders the same bar server-side.
     The two MUST agree: this function runs on boot and overwrites whatever the Liquid
     rendered, so a disagreement here silently wins. */
  function billableTotal(cart){
    return (cart.items || []).reduce(function(sum, it){
      return it.selling_plan_allocation ? sum : sum + it.final_line_price;
    }, 0);
  }

  function updateShipBar(cart){
    var bar = qs('.glowvital-cart .free-ship-bar');
    if (!bar) return;
    var fill = qs('.progress-fill', bar);
    var label = qs('.free-ship-msg .label', bar);
    var status = qs('.free-ship-msg .status', bar);
    var total = billableTotal(cart); // pence, subscription lines excluded
    var allSubscription = cart.item_count > 0 && total === 0;
    var remaining = FREE_SHIP_THRESHOLD - total;
    if (allSubscription || remaining <= 0){
      if (fill) fill.style.width = '100%';
      if (label) label.textContent = allSubscription ? 'Your subscription includes' : 'Your order qualifies for';
      if (status){
        status.classList.remove('pending');
        status.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l5 5L20 7"/></svg> Free UK Delivery';
      }
    } else {
      var pct = Math.max(0, Math.min(100, (total / FREE_SHIP_THRESHOLD) * 100));
      if (fill) fill.style.width = pct + '%';
      if (label) label.textContent = 'Add ' + money(remaining) + ' for';
      if (status){
        status.classList.add('pending');
        status.textContent = 'Free UK Delivery';
      }
    }
  }

  /* ---------- Summary update ---------- */
  function updateSummary(cart){
    var subtotalEl = qs('[data-cart-subtotal]');
    var savingEl  = qs('[data-cart-saving]');
    var savingRow = qs('.sum-line.saving');
    var totalEl   = qs('[data-cart-total]');
    var countEl   = qs('[data-cart-count]');
    var klarnaEl  = qs('[data-cart-klarna]');
    var clearpayEl= qs('[data-cart-clearpay]');

    var subtotal = cart.items_subtotal_price;
    var total    = cart.total_price;
    var saving   = Math.max(0, subtotal - total);

    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    if (totalEl)    totalEl.textContent    = money(total);
    if (countEl)    countEl.textContent    = cart.item_count;
    if (savingEl)   savingEl.textContent   = '− ' + money(saving);
    if (savingRow)  savingRow.style.display = saving > 0 ? '' : 'none';

    if (klarnaEl)   klarnaEl.textContent   = money(Math.round(total / 3));
    if (clearpayEl) clearpayEl.textContent = money(Math.round(total / 4));

    updateShipBar(cart);

    var stickyTotal = qs('.mobile-sticky-checkout [data-mobile-total]');
    if (stickyTotal) stickyTotal.textContent = money(total);

    var checkoutBtn = qs('.cta-checkout');
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;

    // Toggle empty state
    var emptyState = qs('[data-cart-empty]');
    var mainGrid   = qs('[data-cart-grid]');
    if (cart.item_count === 0){
      if (emptyState) emptyState.style.display = 'block';
      if (mainGrid)   mainGrid.style.display   = 'none';
    } else {
      if (emptyState) emptyState.style.display = 'none';
      if (mainGrid)   mainGrid.style.display   = '';
    }

    // Header cart count badge
    qsa('.cart-count .num, [data-header-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
    });
  }

  /* ---------- Refresh items + upsell grid (silent AJAX) ---------- */
  function refreshItemsGrid(){
    return fetch('/cart', { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelector('.glowvital-cart .cart-items');
        var oldItems = qs('.glowvital-cart .cart-items');
        if (newItems && oldItems){
          oldItems.innerHTML = newItems.innerHTML;
          qsa('.glowvital-cart .cart-item').forEach(function(row){ row.__wired = false; });
          initItemWiring();
          qsa('.glowvital-cart .cart-item.reveal').forEach(function(el){ el.classList.add('in'); });
        }
        var newUpsells = doc.querySelector('.glowvital-cart .upsell-list');
        var oldUpsells = qs('.glowvital-cart .upsell-list');
        if (newUpsells && oldUpsells){
          oldUpsells.innerHTML = newUpsells.innerHTML;
          qsa('.glowvital-cart [data-upsell-add], .glowvital-cart [data-upsell-soon]').forEach(function(b){ b.__wired = false; });
          initUpsells();
        }
        var newCount = doc.querySelector('[data-cart-count]');
        var oldCount = qs('[data-cart-count]');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;
      })
      .catch(function(){});
  }

  /* ---------- Qty change ---------- */
  function changeQty(line, newQty, row){
    return postJSON('/cart/change.js', { line: line, quantity: newQty })
      .then(function(cart){
        updateSummary(cart);
        if (newQty === 0 && row){
          row.classList.add('is-removing');
          setTimeout(function(){
            row.remove();
            // If after removal more items exist, refresh the grid so line indices re-number correctly
            if (cart.item_count > 0) refreshItemsGrid();
          }, 380);
        } else {
          // Refresh silently so per-item prices / savings / quantities stay in sync
          refreshItemsGrid();
        }
        return cart;
      })
      .catch(function(err){
        if (row) row.classList.remove('is-removing');
        alert(err.message || 'Could not update cart.');
      });
  }

  /* ---------- Item wiring (qty steppers + remove) ---------- */
  function initItemWiring(){
    qsa('.cart-item').forEach(function(row){
      if (row.__wired) return;
      row.__wired = true;
      var line = parseInt(row.dataset.line, 10);
      var qtyInput = qs('.qty-stepper input', row);
      var minus = qs('.qty-stepper .minus', row);
      var plus  = qs('.qty-stepper .plus', row);
      var remove = qs('.item-remove', row);

      if (minus) minus.addEventListener('click', function(){
        var q = Math.max(0, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = q;
        changeQty(line, q, row);
      });
      if (plus) plus.addEventListener('click', function(){
        var q = Math.min(10, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = q;
        changeQty(line, q, row);
      });
      if (qtyInput){
        qtyInput.addEventListener('change', function(){
          var q = Math.max(0, Math.min(10, parseInt(qtyInput.value, 10) || 1));
          qtyInput.value = q;
          changeQty(line, q, row);
        });
      }
      if (remove) remove.addEventListener('click', function(e){
        e.preventDefault();
        changeQty(line, 0, row);
      });
    });
  }

  /* ---------- Upsell add ---------- */
  function initUpsells(){
    qsa('[data-upsell-add]').forEach(function(btn){
      if (btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', function(){
        if (btn.classList.contains('soon') || btn.classList.contains('sold-out') || btn.disabled) return;
        var id = btn.dataset.variantId;
        if (!id) return;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding…';
        postJSON('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
          .then(function(){ return getCart(); })
          .then(function(cart){
            updateSummary(cart);
            btn.classList.add('added');
            btn.textContent = '✓ Added';
            // Silent refresh of items grid (smooth — no page reload)
            refreshItemsGrid();
            setTimeout(function(){
              btn.classList.remove('added');
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1800);
          })
          .catch(function(err){
            btn.textContent = originalText; btn.disabled = false;
            alert(err.message || 'Could not add.');
          });
      });
    });
    qsa('[data-upsell-soon]').forEach(function(btn){
      if (btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var label = btn.textContent;
        btn.textContent = 'Coming soon';
        setTimeout(function(){ btn.textContent = label; }, 1400);
      });
    });
  }

  /* ---------- Extras (gift / note) ---------- */
  function initExtras(){
    qsa('.extra-toggle').forEach(function(t){
      t.addEventListener('click', function(){
        var open = t.classList.contains('open');
        qsa('.extra-toggle').forEach(function(x){ x.classList.remove('open'); });
        qsa('.extra-content').forEach(function(x){ x.classList.remove('open'); });
        if (!open){
          t.classList.add('open');
          var c = t.nextElementSibling;
          if (c) c.classList.add('open');
        }
      });
    });

    var gift = qs('[data-cart-gift]');
    var note = qs('[data-cart-note]');
    var saveTimer;
    function saveExtras(){
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function(){
        var giftVal = gift ? gift.value.trim() : '';
        var noteVal = note ? note.value.trim() : '';
        // Combine: gift saved to cart.note (visible in admin), order note to attributes
        postJSON('/cart/update.js', {
          note: giftVal,
          attributes: { 'Order Notes': noteVal }
        }).then(function(){
          qsa('.save-hint').forEach(function(h){
            h.classList.add('saved');
            h.textContent = '✓ Saved';
            setTimeout(function(){
              h.classList.remove('saved');
              h.textContent = 'Auto-saves as you type';
            }, 2000);
          });
        }).catch(function(){});
      }, 600);
    }
    if (gift) gift.addEventListener('input', saveExtras);
    if (note) note.addEventListener('input', saveExtras);
  }

  /* ---------- Discount ---------- */
  function initDiscount(){
    var toggle = qs('[data-discount-toggle]');
    var form   = qs('[data-discount-form]');
    var input  = qs('[data-discount-input]');
    var status = qs('[data-discount-status]');
    var checkoutForm = qs('[data-checkout-form]');

    if (toggle && form){
      toggle.addEventListener('click', function(){ form.classList.toggle('open'); });
    }
    if (form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var code = (input.value || '').trim().toUpperCase();
        if (!code) return;
        input.value = code;
        if (checkoutForm){
          checkoutForm.action = '/checkout?discount=' + encodeURIComponent(code);
        }
        if (status){
          status.classList.add('ok');
          status.textContent = '✓ ' + code + ' will apply at checkout';
        }
      });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(){
    qsa('.glowvital-cart .faq-trigger').forEach(function(trigger){
      trigger.addEventListener('click', function(){
        var content = trigger.nextElementSibling;
        var isOpen = trigger.classList.contains('open');
        qsa('.glowvital-cart .faq-trigger').forEach(function(t){ t.classList.remove('open'); });
        qsa('.glowvital-cart .faq-content').forEach(function(c){ c.classList.remove('open'); });
        if (!isOpen){
          trigger.classList.add('open');
          if (content) content.classList.add('open');
        }
      });
    });
  }

  /* ---------- Mobile sticky checkout ---------- */
  function initMobileSticky(){
    var bar = qs('.mobile-sticky-checkout');
    var anchor = qs('.summary-total');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ bar.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.bottom < 0); });
    }, { threshold: 0 });
    io.observe(anchor);

    var go = qs('.mobile-sticky-checkout .go');
    if (go) go.addEventListener('click', function(){
      var cf = qs('[data-checkout-form]');
      if (cf) cf.requestSubmit ? cf.requestSubmit() : cf.submit();
    });
  }

  /* ---------- Reveal ---------- */
  function initReveal(){
    var all = qsa('.glowvital-cart .reveal');
    if (REDUCED || !('IntersectionObserver' in window)){
      all.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    all.forEach(function(el){ io.observe(el); });
    setTimeout(function(){
      all.forEach(function(el){
        if (el.getBoundingClientRect().top < window.innerHeight + 200) el.classList.add('in');
      });
    }, 1800);
  }

  /* ---------- Boot ---------- */
  function boot(){
    if (!qs('.glowvital-cart')) return;
    initItemWiring();
    initUpsells();
    initExtras();
    initDiscount();
    initFaq();
    initMobileSticky();
    initReveal();
    getCart().then(updateSummary).catch(function(){});
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
